<div class="assessment-page">
  <div class="assessment-header">
    <h1 class="assessment-title">AI Video Interview</h1>

    <p class="assessment-subtitle">
      Data Science Intern at Synaptic AI · 45 minutes · 6 questions
    </p>
  </div>

  <div class="card">
    <h3 class="card-title">What will be evaluated</h3>

    <ul class="rules-list">
      <li>Communication clarity and fluency</li>
      <li>Technical knowledge (domain-specific)</li>
      <li>Confidence and composure</li>
      <li>Problem-solving approach</li>
    </ul>
  </div>

  <div class="card">
    <h3 class="card-title">Rules</h3>

    <ul class="rules-list">
      <li>Face the camera clearly throughout</li>
      <li>Speak clearly — AI evaluates speech quality</li>
      <li>You cannot pause or re-record answers</li>
      <li>Each question has a think time and a response time</li>
    </ul>
  </div>

  <div class="card">
    <h3 class="card-title">System check</h3>

    <div class="system-row">
      <div class="left">
        <i class="bi bi-camera"></i>
        Camera
      </div>

      <div
        class="status"
        [ngClass]="cameraDetected ? 'detected' : 'not-detected'"
      >
        {{ cameraDetected ? "Detected" : "Not detected" }}
      </div>
    </div>

    <div class="system-row">
      <div class="left">
        <i class="bi bi-mic"></i>
        Microphone
      </div>

      <div class="status" [ngClass]="micDetected ? 'detected' : 'not-detected'">
        {{ micDetected ? "Detected" : "Not detected" }}
      </div>
    </div>

    <div class="system-row">
      <div class="left">
        <i class="bi bi-speedometer2"></i>
        Internet speed
      </div>

      <div
        class="status"
        [ngClass]="{
          detected: internetStatus === 'Good',
          average: internetStatus === 'Average',
          'not-detected': internetStatus === 'Poor',
        }"
      >
        {{ internetStatus }}

        <span *ngIf="internetSpeed"> ({{ internetSpeed }}) </span>
      </div>
    </div>

    <div>
      <button class="check-btn" (click)="runSystemCheck()">
        Run system check
      </button>
    </div>
  </div>

  <div class="info-box">
    Your responses are evaluated by BeExpert AI in real time. Scores for
    communication, technical knowledge, and confidence are generated
    automatically.
  </div>
  <button class="start-btn" (click)="goToHRMSPage()">Start Interview</button>
</div>
